<template>
  <div class="accordion-group">
    <div class="accordion-heading">
      <a class="accordion-toggle" data-toggle="collapse" data-parent="#collapse-alert" :href="`#collapse${diaryType}`">
        <i :class="['fa-light', icon]"></i>
        SONO PASSATI PIU' DI {{ maxDaysAfterAlert }} GIORNI DALL'ULTIMO DIARIO {{ diaryType.toUpperCase() }} PER I SEGUENTI UTENTI:
      </a>
    </div>
    <div :id="`collapse${diaryType}`" :class="['accordion-body', 'collapse', { in: isActive }]">
      <div class="accordion-inner well well-large alert-controller-welcome" :id="`diary-controller-unwritten-${diaryType}`">
        <span v-for="(diary, index) in itemDiaries" :id="diary.id" :key="index">
          <a :href="diary.href" :data-remote="diary.remote" :target="diary.target">{{ diary.name }} - {{ diary.date }} gg</a>
          <br />
        </span>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.alert-controller-welcome {
  text-align: left;
  color: red;
  min-height: 180px;
  max-height: 350px;
  overflow-y: scroll;
}
</style>
<script>
import apiConnector from '@/epersonam/apiConnector';
export default {
  name: 'alertDiary',
  props: ['maxDaysAfterAlert', 'urlAlertDiary', 'diaryType', 'isActive'],
  data() {
    return {
      itemDiaries: [],
    };
  },
  mounted() {
    if (this.isActive) {
      this.loadElements();
    }
    $('#collapse' + this.diaryType).on('shown', () => {
      if (Object.keys(this.itemDiaries).length === 0) {
        this.loadElements();
      }
    });
  },
  computed: {
    icon() {
      return this.diaryType == 'med' ? 'fa-user-md' : 'fa-user-nurse';
    },
  },
  methods: {
    loadElements() {
      $('#diary-controller-unwritten-' + this.diaryType).addClass('loader-without-modal');
      apiConnector()
        .get(Utils.addGetParam(this.urlAlertDiary, 'type', this.diaryType))
        .then(({ data }) => {
          if (data.hasOwnProperty('links')) {
            this.addElementsInMessage(data);
          } else {
            window.SidekiqUtils.checkJobStatus(
              window.asyncUrl.replace('__JOB_ID__', data.job_id),
              data.job_id,
              this.addElementsInMessage,
              '',
              true,
              5000,
            );
          }
        })
        .catch((err) => {
          $('#diary-controller-unwritten-' + this.diaryType).removeClass('loader-without-modal');
        });
    },
    addElementsInMessage(data) {
      var links;
      links = data['links'].split(',');
      this.itemDiaries = [];
      if (links.length > 0 && links[0] !== '') {
        $.each(links, (i, v) => {
          var link = v.split('|'),
            el = {};
          el['id'] = 'link_diary_' + this.diaryType + '_' + link[1];
          el['href'] = data['link'].replace('placeholder', link[1]);
          if (data['is_user_type']) {
            el['remote'] = true;
          } else {
            el['target'] = '_blank';
          }
          el['name'] = link[0];
          el['date'] = link[2];
          this.itemDiaries.push(el);
        });
      }
      if (this.itemDiaries.length) {
        this.itemDiaries.sort((a, b) => parseInt(b.date) - parseInt(a.date));
      }
      $('#diary-controller-unwritten-' + this.diaryType).removeClass('loader-without-modal');
    },
  },
};
</script>
